export const RECEIVE_SUCCESS_MESSAGE = 'RECEIVE_SUCCESS_MESSAGE'
export const RECEIVE_ERROR_MESSAGE = 'RECEIVE_ERROR_MESSAGE'
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE'
export const ERROR = 'ERROR'
export const SUCCESS = 'SUCCESS'
